import { getCookie } from "./getCookie"

export function EnableCSRF() {
    try {
      if (typeof document != "undefined") {
            const DOMForms = Array.from(document.forms)
            if(DOMForms?.length > 0){
                DOMForms.forEach((form)=>{
                    let Input = document.createElement("input")
                    Input.type = 'hidden'
                    Input.name = 'csrf';
                    Input.value = getCookie('CSRFToken');
                    form.prepend(Input)
                })
            }
      }
    } catch (ex) {
      ex = null;
    }
  }
  